import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PagedRequest } from 'src/app/paged-request.model';
import {
  GetSkillRequest,
  PagedGetCellResponse,
  PagedGetSkillResponse,
  PagedGetSubCellResponse,
} from 'src/app/pages/client/models/client.model';
import { serializeQueryParams } from 'src/app/service-helper';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class SkillService {
  private baseURL: string = environment.apiUrl + '/api/Skill';

  constructor(private http: HttpClient) {}

  get(filter: GetSkillRequest): Observable<PagedGetSkillResponse> {
    const params = serializeQueryParams(filter);
    return this.http.get<PagedGetSkillResponse>(this.baseURL, { params });
  }

  getCells(request: PagedRequest): Observable<PagedGetCellResponse> {
    const params = serializeQueryParams(request);
    return this.http.get<PagedGetCellResponse>(this.baseURL + '/cells', {
      params,
    });
  }

  getSubCells(request: PagedRequest): Observable<PagedGetSubCellResponse> {
    const params = serializeQueryParams(request);
    return this.http.get<PagedGetSubCellResponse>(this.baseURL + '/subcells', {
      params,
    });
  }
}
